import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import * as Models from '../../_shared/models/models-index';
import { SummaryMetricsByDay, EmptySummaryMetricsByDay } from './summaryMetricsByDay.model';
import { OutboundSummaryMetricsByDay, EmptyOutboundSummaryMetricsByDay } from './outboundSummaryMetricsByDay.model';
import { OutboundSummaryMetrics, EmptyOutboundSummaryMetrics } from './outboundSummaryMetrics.model';
import { ConfigurationService, LoggerService } from 'app/_shared/services';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private serviceUri: string = undefined;
  private baseHttpOptions = { headers: { 'Content-Type': 'application/json' } };
  constructor(
    private http: HttpClient,
    private log: LoggerService,
    private config: ConfigurationService) {
    this.config.Config.subscribe((config) => {
      this.serviceUri = config.apiUri;
    });
  }

  getSummaryMetricsByDay(filter: Models.FilterState): Observable<SummaryMetricsByDay> {

    const request: Models.ReportRequest = {
      type: 'SummaryMetricsByDay',
      startDate: filter.startDate,
      endDate: filter.endDate,
      filters: filter.filters
    };

    return this.http.post<SummaryMetricsByDay>(this.serviceUri   + '/report/', request)
        .pipe(catchError(this.handleError<SummaryMetricsByDay>('GetSummaryMetricsByDayReport', EmptySummaryMetricsByDay)));
  }

  getOutboundSummaryMetricsByDay(filter: Models.FilterState): Observable<OutboundSummaryMetricsByDay> {

    const request: Models.ReportRequest = {
      type: 'OutboundSummaryMetricsByDays',
      startDate: filter.startDate,
      endDate: filter.endDate,
      filters: filter.filters
    };

    return this.http.post<OutboundSummaryMetricsByDay>(this.serviceUri + '/report/', request)
      .pipe(catchError(this.handleError<OutboundSummaryMetricsByDay>('GetOutboundSummaryMetricsByDayReport', EmptyOutboundSummaryMetricsByDay)));
  }

  getOutboundSummaryMetrics(filter: Models.FilterState): Observable<OutboundSummaryMetrics> {

    const request: Models.ReportRequest = {
      type: 'OutboundSummaryMetrics',
      startDate: filter.startDate,
      endDate: filter.endDate,
      filters: filter.filters
    };

    return this.http.post<OutboundSummaryMetrics>(this.serviceUri + '/report/', request)
      .pipe(catchError(this.handleError<OutboundSummaryMetrics>('GetOutboundSummaryMetricsReport', EmptyOutboundSummaryMetrics)));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
        console.error(error);
        return of(result as T);
    };
  }
}
